// src/modules/auth/Unauthorized.tsx
import React from 'react';
import { Result, Button, Card, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { LockOutlined } from '@ant-design/icons';

const { Text } = Typography;

export const Unauthorized: React.FC = () => {
  const navigate = useNavigate();
  const { user, role, permissions } = useAuth();

  // Определяем доступные разделы для текущей роли
  const getAvailableSections = () => {
    if (!permissions) return [];
    
    const sections = [];
    if (permissions.can_view_full_dashboard || permissions.can_view_orders_dashboard) {
      sections.push('Дашборд');
    }
    if (permissions.can_manage_orders) {
      sections.push('Заказы');
    }
    if (permissions.can_manage_catalog) {
      sections.push('Каталог');
    }
    if (permissions.can_manage_manufacturing) {
      sections.push('Производство');
    }
    if (permissions.can_manage_users) {
      sections.push('Пользователи');
    }
    
    return sections;
  };

  const availableSections = getAvailableSections();

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{ maxWidth: '600px', width: '100%' }}>
        <Result
          status="403"
          title="Доступ запрещен"
          subTitle={`${user?.first_name || user?.username}, у вас нет прав доступа к этой странице.`}
          icon={<LockOutlined style={{ color: '#ff4d4f' }} />}
          extra={[
            <Button type="primary" key="dashboard" onClick={() => navigate('/dashboard')}>
              Вернуться на главную
            </Button>,
            <Button key="back" onClick={() => navigate(-1)}>
              Назад
            </Button>
          ]}
        />
        
        <Card 
          title="Информация о ваших правах доступа" 
          style={{ marginTop: '20px' }}
        >
          <div style={{ marginBottom: '16px' }}>
            <Text strong>Ваша роль: </Text>
            <Text>{role?.role_display || 'Не определена'}</Text>
          </div>
          
          <div style={{ marginBottom: '16px' }}>
            <Text strong>Доступные разделы:</Text>
            <div style={{ marginTop: '8px' }}>
              {availableSections.length > 0 ? (
                <ul style={{ margin: 0, paddingLeft: '20px' }}>
                  {availableSections.map((section, index) => (
                    <li key={index}>{section}</li>
                  ))}
                </ul>
              ) : (
                <Text type="secondary">Доступных разделов не найдено</Text>
              )}
            </div>
          </div>
          
          <div>
            <Text type="secondary" style={{ fontSize: '12px' }}>
              Если вам нужен доступ к дополнительным разделам, обратитесь к администратору системы.
            </Text>
          </div>
        </Card>
      </div>
    </div>
  );
};